import React, { useState } from 'react';
import * as Collapsible from '@radix-ui/react-collapsible';
import cn from '@/utils/cn';
import Card from '@/components/ui/Card';
import ClassroomCheckboxHeader from './ClassroomCheckboxHeader';
import StudentCheckbox from './StudentCheckbox';
import { NotifyStudentsClassroom } from './NotifyStudentsModal.utils';

interface ClassroomCollapsibleSectionProps {
  alreadyJoinedStudentIds: number[];
  classroom: NotifyStudentsClassroom;
}

const ClassroomCollapsibleSection = ({
  alreadyJoinedStudentIds,
  classroom,
}: ClassroomCollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible.Root
      className={cn(
        'first-of-type:tw-rounded-t first-of-type:tw-border-t last-of-type:tw-rounded-b tw-overflow-hidden',
        'tw-border tw-border-t-0 tw-border-med-grey tw-border-solid',
      )}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <Card
        className={cn(
          'allow-list-style tw-min-h-min tw-min-w-min',
          'tw-shadow-none hover:tw-shadow-none tw-rounded-none',
        )}
      >
        <Collapsible.Trigger asChild>
          <div
            className={cn(
              'tw-bg-white tw-w-full tw-px-3.5 tw-py-2.5 tw-box-border tw-cursor-pointer',
              'focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-tci-purple',
            )}
            role="button"
            tabIndex={0}
          >
            <ClassroomCheckboxHeader
              alreadyJoinedStudentIds={alreadyJoinedStudentIds}
              classroom={classroom}
              isOpen={isOpen}
            />
          </div>
        </Collapsible.Trigger>
        <Collapsible.CollapsibleContent className="CollapsibleContent">
          <Card.Body className="tw-py-3.5 tw-pl-12 tw-bg-light-grey">
            {classroom.students.map(student => (
              <StudentCheckbox
                key={student.id}
                alreadyJoined={alreadyJoinedStudentIds.includes(student.id)}
                classroom={classroom}
                student={student}
              />
            ))}
          </Card.Body>
        </Collapsible.CollapsibleContent>
      </Card>
    </Collapsible.Root>
  );
};

export default ClassroomCollapsibleSection;
